const ERR_OK = parseInt(ArmusScript.ERR_OK().toString(), 10);
const ERR_ILLEGAL = parseInt(ArmusScript.ERR_ILLEGAL().toString(), 10);
const ERR_WARNING = parseInt(ArmusScript.ERR_WARNING().toString(), 10);

/**
 * I strip the last segment of a multi-part key. E.g., make two-part version key
 * from a three-part entity key.
 */
export function getKeyPrefix(key) {
    const parts = key.split("/").filter(it => it);
    if (parts.length === 1) {
        throw new Error(`Single-part key '${key}' has no prefix`);
    }
    parts.pop();
    return parts.join("/");
}

export function isOk(code) {
    return code === ERR_OK;
}

export function isWarning(code) {
    return code >= ERR_WARNING && code < ERR_ILLEGAL;
}

export function isIllegal(code) {
    return code >= ERR_ILLEGAL;
}

export function sprintf(format) {
    let result = format;
    let i = 1;
    const l = arguments.length;
    while (i < l) {
        result = result.replace(/%s/, arguments[i]);
        i++;
    }
    return result;
}



// WEBPACK FOOTER //
// ./app/jsmodel/utils.js